export const INPUT_LENGTH = {
  min: 5,
  textField: 255,
  textArea: 2000,
  bigTextArea: 5000,
};
